import { Grid, makeStyles } from "@material-ui/core";
import { Edit } from "react-admin";
import CustomForm from "./CustomForm";
const useStyles = makeStyles((theme) => ({
  height100: {
    height: "100%",
    marginTop: 0,
  },
}));
const LeftGridEdit = (props) => {
  const {
    children,
    onSuccess,
    onFailure,
    transform,
    validate,
    noDelete = false,
    disabled = false,
  } = props;
  const classes = useStyles();
  return (
    <Grid item xs={8} style={{ height: "100%" }}>
      <Edit
        actions={null}
        style={{
          height: "100%",
          marginTop: 0,
          paddingTop: 30,
          boxSizing: "border-box",
        }}
        classes={{ main: classes.height100 }}
        mutationMode="pessimistic"
        onSuccess={onSuccess}
        onFailure={onFailure}
        transform={transform}
        {...props}
      >
        <CustomForm
          fromEdit={true}
          noDelete={noDelete}
          validate={validate}
          disabled={disabled}
        >
          {children}
        </CustomForm>
      </Edit>
    </Grid>
  );
};

export default LeftGridEdit;
